import { DefaultPortModel } from "@projectstorm/react-diagrams";
import { toast } from "react-toastify";
import CustomLinkModel from "../../links/CustomLinkModel";
import StopLinkModel from "../../links/StopLink/StopLinkModel";

export default class CustomPortModel extends DefaultPortModel {
  constructor(options) {
    super({ ...options, type: "custom-port" });
  }

  createLinkModel() {
    // check if port is correct (we need Out port)
    if (this.options.in) {
      toast.error("You need to drag a link from Out Port.");
      return false;
    }
    // only one link is allowed per port
    if (Object.keys(this.getLinks()).length > 0) {
      toast.error("You can drag only one link from a port.");
      return false;
    }
    if (this.parent.type === "stop") {
      return new StopLinkModel();
    }

    return new CustomLinkModel();
  }
}
